<template>
  <div v-if="isVisible" id="lm-leaflet-map" :style="{ height }">
    <l-map
      style="height: 100%; width: 100%"
      :zoom="Number(zoom)"
      :center="centerMapCoordinateComputed"
      :options="options"
    >
      <l-tile-layer :url="tile" />
      <l-marker v-if="markerLatLng.length" :lat-lng="markerLatLng" ></l-marker>
    </l-map>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'

export default {
  data () {
    return {
      defaultLocation: process.env.VUE_APP_DEFAULT_GEOLOCATION ? process.env.VUE_APP_DEFAULT_GEOLOCATION.split(',').map(i => parseFloat(i)) : [-34.6037389, -58.3815704]
    }
  },
  components: {
    'l-map': LMap,
    'l-tile-layer': LTileLayer,
    'l-marker': LMarker
  },
  props: {
    isVisible: {
      type: Boolean,
      default: true
    },
    options: {
      type: Object,
      default: () => ({ scrollWheelZoom: false })
    },
    tile: {
      type: String,
      default: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png'
    },
    markerLatLng: {
      type: Array,
      default: () => []
    },
    centerMapCoordinate: {
      type: Array,
      default: () => this?.defaultLocation
    },
    zoom: {
      type: [Number, String],
      default: 16
    },
    height: {
      type: String,
      default: '400px'
    }
  },
  computed: {
    centerMapCoordinateComputed () {
      if (this.centerMapCoordinate?.length) {
        return this.centerMapCoordinate
      } else {
        return this.defaultLocation
      }
    }
  }
}
</script>
